/* eslint-disable */

import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { formatDate } from '../../../utils';

import { getProductCoverage, listBenefits } from '../../../apiCalls';
import { openCoverageAccordion } from '../../../actions/coverageActions';
import { closeModalDetail } from '../../../actions/purchaseActions';

import { useDetectClickOutsideElement } from '../../../hooks/useDetectClickOutsideElement';

export class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = { isActive: false };
    this.openCloseAccordion = this.openCloseAccordion.bind(this);
  }

  openCloseAccordion() {
    this.props.openCoverageAccordion(this.props.code);
  }

  render() {
    let containerClass = 'accordion ' + (this.props.opened ? 'active' : '');

    return (
      <div className="tableline">
        <div className="text">
          <span>{this.props.name}</span>
          <span>{this.props.coverage}</span>
        </div>
      </div>
    );
  }
}

export class AccordionContainer extends Component {
  render() {
    let content = ``;
    return [
      <div className="tableheader">{this.props.title}</div>,
      <div className="tablecontents">
        {this.props.benefits.map((benefit, i) => {
          let content = this.props.benefits_list.filter((b, i) => b.code == benefit.code);
          content = content.length >= 1 ? content[0].long_description : '';
          return (
            <Accordion
              {...benefit}
              key={benefit.code}
              content={content}
              openCoverageAccordion={this.props.openCoverageAccordion}
            />
          );
        })}
      </div>,
    ];
  }
}

export class AccordionGroup extends Component {
  constructor(props) {
    super(props);

    getProductCoverage(this.props.match.params);
    listBenefits();
  }

  render() {
    let categories = this.props.productCoverage.benefits;
    let accordionContainers = [];

    for (let category in categories)
      accordionContainers.push(
        <AccordionContainer
          title={category}
          key={category}
          benefits={categories[category]}
          benefits_list={this.props.benefits_list}
          openCoverageAccordion={this.props.openCoverageAccordion}
        />
      );

    let begin_date = this.props.match.params.begin_date,
      end_date = this.props.match.params.end_date;

    let b_date = formatDate(begin_date);
    let e_date = formatDate(end_date);

    return <p className="modaltable">{accordionContainers}</p>;
  }
}

const CoverageModal = (props) => {
  if (!props.isModalDetailActive) return <div></div>;

  const { containerRef } = useDetectClickOutsideElement({ onClickOutside: props.closeModalDetail });

  return (
    <div className="comp_modalpagamento mobile-roof">
      <div className="modalcontents mobile-modal" ref={containerRef}>
        <div className="contents">
          <div className="modaltop">
            <div className="title">Detalhes da cobertura:</div>
            <div onClick={props.closeModalDetail} className="close-btn">
              <img src="/assets/images/icons/close.svg" alt="close button" />
            </div>
          </div>

          <div className="modalmiddle">
            <AccordionGroup {...props} />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  productInfo: state.coverage.productInfo,
  productCoverage: state.coverage.productCoverage,
  benefits_list: state.purchase.benefits_list,
  isModalDetailActive: state.purchase.isModalDetailActive,
});

const mapDispatchToProps = {
  openCoverageAccordion,
  closeModalDetail,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CoverageModal));



// WEBPACK FOOTER //
// ./src/components/purchase/accordion/Accordion.jsx